export default "__VITE_ASSET__CjL2Jh79__"